<template>
  <b-container fluid>
    <h3 class="mt-3 mb-3">Drivers</h3>

    <div class="action_bar mb-3">
      <b-button class="btn-action-lg" size="sm" variant="info" :to="{name: 'driver_manage'}">
        Manage Drivers
      </b-button>
    </div>

    <div class="search_bar mb-3">
      <b-row>
        <b-col cols="2" class="pr-1">
          <b-form-input
            id="input-small"
            size="sm"
            type="text"
            placeholder="Name / Phone"
            v-model="search_criteria.keyword"
          ></b-form-input>
        </b-col>
        <b-col class="text-left p-0">
          <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
            <font-awesome-icon class="mr-1" icon="search"/>Search
          </b-button>
        </b-col>
      </b-row>
    </div>

    <b-pagination
      size="sm"
      :total-rows="total_rows"
      v-model="currentPage"
      :per-page="TABLE_LIMIT"
      @change="onPageChange"
      :limit="PAGING_LIMIT"
    ></b-pagination>

    <b-table small outlined striped hover :items="items" :fields="fields">

      <template v-slot:cell(action)="data">
        <b-button class="btn-action" size="sm" variant="info" :to="{ name: 'driver_trackings', params: { id: data.item.id }}">
          <font-awesome-icon class="mr-1" icon="box"/>Trackings
        </b-button>
        <b-button
          class="btn-action"
          size="sm"
          variant="danger"
          @click.stop="showModal_delete_confirm(data.item)"
        >
          <font-awesome-icon class="mr-1" icon="trash-alt"/>Delete
        </b-button>
      </template>
    </b-table>

    <b-pagination
      size="sm"
      :total-rows="total_rows"
      v-model="currentPage"
      :per-page="TABLE_LIMIT"
      @change="onPageChange"
      :limit="PAGING_LIMIT"
    ></b-pagination>

    <b-modal ref="modal_delete_confirm" centered hide-footer hide-header>
      <div class="d-block">Are you sure to delete this record?</div>
      <div class="text-right">
        <b-btn class="mt-3" variant="outline-danger" @click="hideModal_delete_confirm">No</b-btn>
        <b-btn class="mt-3" variant="outline-success" @click="confirmDelete()">Yes</b-btn>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import TextCollapse from "@/components/TextCollapse.vue";

const fields = [
  {
    key: "id",
    label: "ID"
  },
  {
    key: "username",
    label: "Username"
  },
  {
    key: "name",
    label: "Name"
  },
  {
    key: "phone",
    label: "Phone"
  },
  {
    key: "action",
    label: "Action"
  }
];

export default {
  name: "drivers",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    TextCollapse
  },
  data() {
    return {
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      search_criteria: {
        keyword: ""
      },
      showDismissibleAlert: false
    };
  },
  async created() {
    await this.getDrivers();
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    async getDrivers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "driver_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          user_id: this.$store.state.user_obj.user_id,
        }
      });
      this.items = response.data.drivers;
      this.total_rows = parseInt(response.data.total_rows);

      this.loader.hide();
    },

    onSearch() {
      this.getDrivers();
    },

    checkAllRows() {
      console.log("checkAllRows");
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getDrivers();
    },

    showModal_delete_confirm(item) {
      this.$refs.modal_delete_confirm.item = item;
      this.$refs.modal_delete_confirm.show();
    },

    hideModal_delete_confirm() {
      this.$refs.modal_delete_confirm.hide();
    },

    async confirmDelete() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "driver_delete.php",
        data: {
          driver_id: this.$refs.modal_delete_confirm.item.id
        }
      });

      if (response.data.status == "success") {
        this.getDrivers();
      } else {
      }

      this.$refs.modal_delete_confirm.hide();
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Drivers.vue